module.exports = __webpack_public_path__ + "static/media/ios-musical-notes.9309b13a.svg";